var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3325 2.25391L16.9966 0.917969C16.5747 0.496094 15.977 0.25 15.4145 0.25C14.852 0.25 14.2544 0.496094 13.8325 0.917969L11.1958 3.55469L10.0005 4.75L1.42234 13.3281L1.00047 17.3359C0.930156 17.8281 1.31687 18.25 1.80906 18.25C1.84422 18.25 1.87937 18.25 1.91453 18.25L5.92234 17.8281L14.5005 9.25L15.6958 8.05469L18.3325 5.41797C19.2114 4.53906 19.2114 3.13281 18.3325 2.25391ZM5.14891 16.2109L2.79344 16.457L3.03953 14.1016L11.1606 5.94531L12.2505 4.85547L14.395 7L13.3052 8.08984L5.14891 16.2109ZM17.1372 4.22266L15.5903 5.80469L13.4458 3.66016L15.0278 2.11328C15.1684 1.97266 15.3442 1.9375 15.4145 1.9375C15.4848 1.9375 15.6606 1.97266 15.8012 2.11328L17.1372 3.44922C17.3481 3.66016 17.3481 4.01172 17.1372 4.22266Z",
    fill: "#9C268F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/icEdit.d5fd214c.svg";
export { ForwardRef as ReactComponent };